import { IconID } from '@thoughtspot/radiant-react/widgets/icon';
import { SpotlightItemType } from './spotlight.types';
export const getQuickLinks = (t) => [
    {
        id: 'quick-admin-settings',
        label: t('sidebar.header.newNav.title'),
        labelKey: 'sidebar.header.newNav.title',
        description: t('spotlight.quickLink.adminSettings.description'),
        icon: IconID.COG,
        type: SpotlightItemType.NAVIGATION,
        path: '/admin',
        keywords: ['admin', 'settings', 'configuration'],
    },
    {
        id: 'quick-profile-settings',
        label: t('spotlight.quickLink.profileSettings'),
        labelKey: 'spotlight.quickLink.profileSettings',
        description: t('spotlight.quickLink.profileSettingsDesc'),
        icon: IconID.COG,
        type: SpotlightItemType.NAVIGATION,
        path: '/user-preference',
        keywords: ['profile', 'preferences', 'account'],
    },
    {
        id: 'quick-community',
        label: t('spotlight.quickLink.community'),
        labelKey: 'spotlight.quickLink.community',
        description: t('spotlight.quickLink.communityDesc'),
        icon: IconID.INFORMATION_CIRCLE,
        type: SpotlightItemType.NAVIGATION,
        action: () => window.open('https://community.thoughtspot.com', '_blank'),
        keywords: ['community', 'help', 'forum'],
    },
    {
        id: 'quick-developer-docs',
        label: t('spotlight.quickLink.developerDocs'),
        labelKey: 'spotlight.quickLink.developerDocs',
        description: t('spotlight.quickLink.developerDocsDesc'),
        icon: IconID.INFORMATION_CIRCLE,
        type: SpotlightItemType.NAVIGATION,
        action: () => window.open('https://developers.thoughtspot.com', '_blank'),
        keywords: ['developer', 'docs', 'documentation', 'api'],
    },
    {
        id: 'quick-muze-charts-docs',
        label: t('spotlight.quickLink.muzeDocs'),
        labelKey: 'spotlight.quickLink.muzeDocs',
        description: t('spotlight.quickLink.muzeDocsDesc'),
        icon: IconID.INFORMATION_CIRCLE,
        type: SpotlightItemType.NAVIGATION,
        action: () => window.open('https://developers.thoughtspot.com/charts', '_blank'),
        keywords: ['muze', 'charts', 'docs', 'documentation'],
    },
];
export const QUICK_LINKS = getQuickLinks((key) => key);
export const getCreateActionItems = (routePaths, t = (key) => key, canCreateConnection = false) => [
    {
        id: 'action-create-spotter',
        label: t('spotlight.create.spotterChat'),
        labelKey: 'spotlight.create.spotterChat',
        icon: IconID.SPOTTER,
        type: SpotlightItemType.CREATE,
        path: routePaths.ConvAssist,
        keywords: ['new', 'create', 'spotter', 'ai', 'chat', 'conversation'],
    },
    {
        id: 'action-create-answer',
        label: t('spotlight.create.answer'),
        labelKey: 'spotlight.create.answer',
        icon: IconID.PLUS,
        type: SpotlightItemType.CREATE,
        path: 'insights/answer',
        keywords: ['new', 'create', 'answer', 'search', 'query'],
    },
    {
        id: 'action-create-liveboard',
        label: t('spotlight.create.liveboard'),
        labelKey: 'spotlight.create.liveboard',
        icon: IconID.PLUS,
        type: SpotlightItemType.CREATE,
        path: routePaths.HomeLiveboardsReact,
        openModalOnNav: true,
        keywords: ['new', 'create', 'liveboard', 'dashboard', 'pinboard'],
    },
    {
        id: 'action-create-collection',
        label: t('spotlight.create.collection'),
        labelKey: 'spotlight.create.collection',
        icon: IconID.PLUS,
        type: SpotlightItemType.CREATE,
        path: '/insights/collections',
        openModalOnNav: true,
        keywords: ['new', 'create', 'collection', 'folder', 'organize'],
    },
    ...(canCreateConnection
        ? [
            {
                id: 'action-create-connection',
                label: t('spotlight.create.connection'),
                labelKey: 'spotlight.create.connection',
                icon: IconID.PLUS,
                type: SpotlightItemType.CREATE,
                path: routePaths.EmbraceConnection,
                keywords: [
                    'new',
                    'create',
                    'connection',
                    'data source',
                    'database',
                ],
            },
        ]
        : []),
];
export const CREATE_ACTION_IDS = [
    'action-create-spotter',
    'action-create-answer',
    'action-create-liveboard',
    'action-create-collection',
    'action-create-connection',
];
export const TYPE_LABEL_CONFIG = {
    answer: {
        keywords: ['answer'],
        label: 'Answer',
    },
    answerInLiveboard: {
        keywords: ['answer', 'liveboard', 'lb'],
        label: 'Answer (in a LB)',
    },
    liveboard: {
        keywords: ['liveboard'],
        label: 'Liveboard',
    },
    model: {
        keywords: ['model'],
        label: 'Model',
    },
    adminSettings: {
        keywords: ['admin', 'settings'],
        label: 'Admin Settings',
    },
    help: {
        keywords: ['help', 'docs', 'documentation', 'community'],
        label: 'Help',
    },
    spotter: {
        keywords: ['spotter', 'conv-assist', 'conversation'],
        label: 'Spotter',
    },
    table: {
        keywords: ['tables', 'table'],
        label: 'Table',
    },
};
export const DEFAULT_TYPE_LABELS = {
    navigation: 'Navigate',
    create: 'Create',
};
export const RECENT_CONFIG = {
    maxItems: 10,
    displayCount: 6,
};
export const SPOTLIGHT_FETCH_BATCH_SIZE = 100;
export const KEYBOARD_SHORTCUTS = {
    navigate: '↑ ↓',
    openNewTab: 'Shift + ↵',
    openInSpotter: '⌘ + ↵',
    open: '↵',
};
const SLASH_ITEM_DEFAULT_ORDER = [
    'slash-liveboard',
    'slash-answers',
    'slash-admin',
    'slash-create',
    'slash-spotter',
    'slash-models',
    'slash-tables',
    'slash-collections',
];
export const getOrderedSlashMenuItems = (items, currentPath) => {
    const byId = new Map(items.map(item => [item.id, item]));
    const ordered = (ids) => ids.flatMap(id => (byId.has(id) ? [byId.get(id)] : []));
    if (currentPath.startsWith('/admin')) {
        const promoted = ['slash-admin'];
        const rest = SLASH_ITEM_DEFAULT_ORDER.filter(id => !promoted.includes(id));
        return ordered([...promoted, ...rest]);
    }
    if (currentPath.startsWith('/data') ||
        currentPath.startsWith('/worksheet')) {
        const promoted = ['slash-models', 'slash-tables', 'slash-collections'];
        const rest = SLASH_ITEM_DEFAULT_ORDER.filter(id => !promoted.includes(id));
        return ordered([...promoted, ...rest]);
    }
    return ordered(SLASH_ITEM_DEFAULT_ORDER);
};
export const getSlashMenuItems = (t) => [
    {
        id: 'slash-admin',
        label: t('sidebar.header.newNav.title'),
        labelKey: 'sidebar.header.newNav.title',
        icon: IconID.COG,
        type: SpotlightItemType.NAVIGATION,
        path: '/admin',
        keywords: ['admin', 'settings'],
    },
    {
        id: 'slash-answers',
        label: t('homeleftpanel.answers'),
        labelKey: 'homeleftpanel.answers',
        icon: IconID.ANSWER,
        type: SpotlightItemType.NAVIGATION,
        path: '/answers',
        keywords: ['answers', 'search'],
    },
    {
        id: 'slash-liveboard',
        label: t('homeleftpanel.liveboards'),
        labelKey: 'homeleftpanel.liveboards',
        icon: IconID.PINBOARD_NEW,
        type: SpotlightItemType.NAVIGATION,
        path: '/pinboards',
        keywords: ['liveboard', 'dashboard', 'pinboard'],
    },
    {
        id: 'slash-create',
        label: t('CREATE'),
        labelKey: 'CREATE',
        icon: IconID.PLUS,
        type: SpotlightItemType.CREATE,
        path: '/answer',
        keywords: ['create', 'new', 'add'],
    },
    {
        id: 'slash-collections',
        label: t('homeleftpanel.collections'),
        labelKey: 'homeleftpanel.collections',
        icon: IconID.COLLECTION,
        type: SpotlightItemType.NAVIGATION,
        path: '/home',
        keywords: ['collections', 'folders', 'organize'],
    },
    {
        id: 'slash-models',
        label: t('MODELS'),
        labelKey: 'MODELS',
        icon: IconID.SAVE_WORKSHEET,
        type: SpotlightItemType.NAVIGATION,
        path: '/worksheet',
        keywords: ['models', 'worksheets', 'data'],
    },
    {
        id: 'slash-tables',
        label: t('TABLES'),
        labelKey: 'TABLES',
        icon: IconID.CHART_TABLE,
        type: SpotlightItemType.NAVIGATION,
        path: '/data/tables',
        keywords: ['tables', 'data', 'source', 'database'],
    },
    {
        id: 'slash-spotter',
        label: t('gnav.appSwitcher.SPOTTER'),
        labelKey: 'gnav.appSwitcher.SPOTTER',
        icon: IconID.SPOTTER,
        type: SpotlightItemType.NAVIGATION,
        path: '/conv-assist',
        keywords: ['spotter', 'ai', 'chat', 'conversation'],
    },
];
//# sourceMappingURL=spotlight-config.js.map